<template>
	<v-container>
			<v-col>
				<h1>Action Plan : <span style="font-size: 0.8em;">{{ this.$store.getters.selectedTitle }}</span></h1>
				<br/>
			</v-col>
			<v-data-table
				theme--light
				:headers="headers"
				:items="connections"
				:search="search"
				:items-per-page="20"
				class="light table"
				hide-default-footer
				:footer-props="{
					'items-per-page-options': [5, 10, 15, 20],
				}"
			>
				<template v-slot:header="{ headers }">
					<thead>
						<tr>
							<th
								v-for="header in headers"
								:key="header.text"
								class="custom-header"
							>
								{{ header.text }}
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item.Description="{ item }">
					<td style="text-align: justify; padding: 5px 0px;"><span>{{ item.Description }}</span></td>
				</template>
				<template v-slot:item.Connection_to_risk="{ item }">
					<td style="text-align: center;"><span>{{ item.Connection_to_risk }}</span></td>
				</template>
				<template v-slot:item.Status="{ item }">
					<td style="text-align: center;" :class="getStatusClass(item.Status)">
						<span>{{ getStatusText(item.Status) }}</span>
						
					</td>
				</template>
			</v-data-table>
	</v-container>
</template>

<script>
import { actionplanAPI } from "../../api/csr/actionplan"
import LoadingState from "../../consts/LoadingState"
import { mapGetters } from "vuex"

export default {
	data() {
		return {
			dialogDelete: false,
			connections: [],
			avgScore: [],
			dropdownItems: [
				{ title: "Total score", action: this.sortByTotalScore },
				{ title: "Human rights", action: this.sortByHumanRights },
				{ title: "Labour", action: this.sortByLabour },
				{ title: "Environment", action: this.sortByEnvironment },
				{ title: "Anticorruption", action: this.sortByAnticorruption },
				{ title: "Transparency Law", action: this.sortByTransparencyLaw },
			],
			search: "",
			headers: [
				{
					text: "Mitigation",
					align: "start",
					value: "Mitigation",
					sortable: false,
					width:"15%",
				},
				{
					text: "Description",
					align: "center",
					value: "Description",
					sortable: false,
					width:"60%",
				},
				{
					text: "Risk Connection",
					align: "center",
					value: "Connection_to_risk",
					sortable: false,
				},
				{
					text: "Status",
					align: "center",
					value: "Status",
					sortable: false,
					width:"10%",
				},
			],
		}
	},
	computed: {
		...mapGetters([
			"selectedId",
			"selectedYear",
			"selectedTitle",
			"selectedDescription",
			"selectedStatus",
		]),
		isActionAllowed() {
			return this.selectedStatus === "Active"
		},
	},
	watch: {
		selectedId(newVal) {
			console.log("Selected ID changed Risk Description:", newVal)
			this.loadActionItems(newVal)
		},
	},
	mounted() {
		this.loadActionItems(this.selectedId)
	},
	methods: {
		loadActionItems(id) {
			this.connections = []
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			actionplanAPI
				.getAll(id)
				.then((data) => {
					let editbutton = ""
					for (let entry of data[0]) {
						this.connections.push({
							ID: entry.id,
							Mitigation: entry.Mitigation,
							Description: entry.Description,
							Connection_to_risk: entry.Connected_to_risk,
							Status: entry.Status,
							Assigned: entry.Assigned,
							Created: entry.Created.split("T")[0],
							ExpiryDate: entry.ExpiryDate.split("T")[0],
							editbutton: editbutton,
						})
					}
					// Can't make a check inside for loop (eslint), have to remove it outside. Not a good fix.
					/*this.connections = this.connections.filter(function( obj ) {
						return obj.clientID !== 1 // clientID 1 is the user (client accessing the portal).
					})*/
					// Used by old method of showing sustainability
					//this.averageScore() // Calculating average score of all suppliers
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.$emit("row-count", this.connections.length)
					this.$emit("ready")
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
					this.$emit("row-count", 0)
					this.$emit("ready")
				})
		},
		deleteItem(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},
		updateItem(item) {
			this.$router.push({
				path: "/csr/riskmatrix/updateaction",
				query: {
					itemId: item.ID,
				},
			})
		},
		removeRow() {
			this.dialogDelete = false
			let index = this.connections.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			actionplanAPI
				.deleteAction(this.itemToDelete.ID)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Action Plan item was successfully removed from the list.",
						{ root: true }
					)
					this.connections.splice(index, 1)
					window.location.href = "/csr/riskmatrix/riskpage"
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getStatusText(status) {
			if (status == 1) {
				return "Done"
			} else if (status == 2) {
				return "Started"
			} else if (status == 3) {
				return "Planned"
			} else {
				return ""
			}
		},
		getStatusClass(status) {
			if (status == 1) {
				return "success--text"
			} else if (status == 2) {
				return "warning--text"
			} else if (status == 3) {
				return "red--text"
			} else {
				return ""
			}
		},
	},
}
</script>

<style>
.v-progress-circular {
	margin: 0rem;
}

.addnewbutton {
	display: flex;
	justify-content: flex-end;
}
.custom-header {
	font-size: 100px;
}
.v-data-table .v-data-table-header tr th {
	font-size: 15px !important;
	color: #217b7f !important;
}
</style>
